import { render, staticRenderFns } from "./HighlightedLenders.vue?vue&type=template&id=96ecb29a&"
import script from "./HighlightedLenders.vue?vue&type=script&lang=js&"
export * from "./HighlightedLenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports